import { Paper, Skeleton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AggregateCardConfig } from "..";
import { MetricValue } from "./MetricValue";

export const AggregateCard = ({ icon, type, data, isDelta, isLoading, chart }: AggregateCardConfig) => {
	const { t } = useTranslation("dataInsights.rootcause");

	if (isLoading) {
		return (
			<Paper sx={{ flex: 1 }} elevation={0}>
				<Skeleton variant="rounded" height={400} width="100%" />
			</Paper>
		);
	}
	return (
		<Paper sx={{ flex: 1, p: 2, minWidth: 0 }} elevation={0}>
			<Stack gap={2}>
				<Stack direction="row" spacing={1} alignItems="center">
					{icon}

					<Typography variant="h6" color="primary">
						{t(`root cause results/aggregate scenario/${type}`)}
					</Typography>
				</Stack>

				<Stack gap={2}>
					<MetricValue
						label={t("root cause results/aggregate scenario/co2e")}
						value={data.co2?.value}
						measure={data.co2?.measure}
						isDelta={isDelta}
					/>

					<MetricValue
						label={t("root cause results/aggregate scenario/tkm")}
						value={data.tkm?.value}
						measure={data.tkm?.measure}
						isDelta={isDelta}
					/>

					<MetricValue
						label={t("root cause results/aggregate scenario/co2e per tkm")}
						value={data.intensity?.value}
						measure={data.intensity?.measure}
						isDelta={isDelta}
						maximumFractionDigits={4}
					/>

					<MetricValue
						label={t("root cause results/aggregate scenario/average km")}
						value={data.avgDistance?.value}
						measure={data.avgDistance?.measure}
						isDelta={isDelta}
					/>

					<Stack gap={1}>
						<Typography variant="subtitle2" fontWeight={500} color="textSecondary">
							{t("root cause results/aggregate scenario/tkm split per mode")}{" "}
							{isDelta && t("root cause results/aggregate scenario/delta")}
						</Typography>
						{chart}
					</Stack>
				</Stack>
			</Stack>
		</Paper>
	);
};
